import src from "./flask.png";
export default { src: src, aspect: 0.1921, width: 516, height: 2686 };